import {axios as http} from "@/plugins/http"

export default class Api {
    static getImageOverlay(shopHost) {
        return http.post("/api/v1/post/mark-ad-auto/get-image-overlay", {
            "shop_host": shopHost,
        }).then((resp) => {
            return resp.data
        })
    }

    static setImageOverlay(postId, text, status) {
        return http.post("/api/v1/post/mark-ad-auto/set-image-overlay", {
            "post_id": postId,
            "text": text,
            "status": status,
        }).then((resp) => {
            return resp.data
        })
    }

    static previewImageOverlay(postId, text, status) {
        return http.post("/api/v1/post/mark-ad-auto/preview-image-overlay", {
            "post_id": postId,
            "text": text,
            "status": status,
        }).then((resp) => {
            return resp.data
        })
    }
}
